import "./AddressForm.css";

function AddressForm({
  providerData,
  setProviderData,
}) {

  const address = providerData.address || {};

  const handleChange = (field, value) => {

    setProviderData({

      ...providerData,

      address: {

        ...address,

        [field]: value,

      },

    });

  };

  return (

    <div className="address-form">

      <h3>

        Business Address

      </h3>

      <div className="address-grid">

        <div className="form-group">

          <label>

            Door Number *

          </label>

          <input

            type="text"

            placeholder="Door Number"

            value={address.doorNo || ""}

            onChange={(e)=>

              handleChange(

                "doorNo",

                e.target.value

              )

            }

          />

        </div>

        <div className="form-group">

          <label>

            Street *

          </label>

          <input

            type="text"

            placeholder="Street"

            value={address.street || ""}

            onChange={(e)=>

              handleChange(

                "street",

                e.target.value

              )

            }

          />

        </div>

        <div className="form-group">

          <label>

            Landmark

          </label>

          <input

            type="text"

            placeholder="Landmark"

            value={address.landmark || ""}

            onChange={(e)=>

              handleChange(

                "landmark",

                e.target.value

              )

            }

          />

        </div>

        <div className="form-group">

          <label>

            Area *

          </label>

          <input

            type="text"

            placeholder="Area"

            value={address.area || ""}

            onChange={(e)=>

              handleChange(

                "area",

                e.target.value

              )

            }

          />

        </div>

        <div className="form-group">

          <label>

            City *

          </label>

          <input

            type="text"

            placeholder="City"

            value={address.city || ""}

            onChange={(e)=>

              handleChange(

                "city",

                e.target.value

              )

            }

          />

        </div>

        <div className="form-group">

          <label>

            State *

          </label>

          <input

            type="text"

            placeholder="State"

            value={address.state || ""}

            onChange={(e)=>

              handleChange(

                "state",

                e.target.value

              )

            }

          />

        </div>

        <div className="form-group">

          <label>

            Pincode *

          </label>

          <input

            type="text"

            maxLength={6}

            placeholder="Pincode"

            value={address.pincode || ""}

            onChange={(e)=>

              handleChange(

                "pincode",

                e.target.value

              )

            }

          />

        </div>

      </div>

    </div>

  );

}

export default AddressForm;